import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Box, CircularProgress } from '@mui/material'
import { IStore } from '../../store/types'
import { CurrentDialog } from '../../components/SearchWorkspace/CurrentDialog'
import { useAppDispatch } from '../../store'
import { getDialog, getDialogMessages } from '../../store/searchChatsTechSupport/actions'
import { SearchChatsTechSupportActions } from '../../store/searchChatsTechSupport'
import { InnerHeight, SIZE_PROG, TechChatStatus } from '../../utils/consts'
import { ChatHeaderInfo } from '../../components/ChatHeaderInfo'
import { ROUTES } from '../../utils/routes'
import { createDialog } from '../../store/techSupport/actions'

export const CurrentDialogTechSupport: React.FC = () => {
  const { searchChatsTechSupport, configurations } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { id } = useParams()

  React.useEffect(() => {
    if (id) {
      dispatch(getDialog(Number(id)))
    }
  }, [])

  const handleGetDialogMessages = (data: { id: number; page: number }, callback?: () => void) => {
    dispatch(getDialogMessages(data)).then(callback)
  }

  const handleCloseDialog = () => {
    dispatch(SearchChatsTechSupportActions.setDialog(null))
    navigate(ROUTES.changeSearch(''))
  }

  const handleCreateDialog = (callback: () => void) => {
    if (!searchChatsTechSupport.dialog) return null
    dispatch(createDialog(searchChatsTechSupport.dialog.chat_id)).then((res) => {
      callback()
      if (res.meta.requestStatus === 'fulfilled') {
        navigate(
          `${ROUTES.chatsTechSupport}/${searchChatsTechSupport.dialog?.chat_id}?status=${TechChatStatus.INITIATED}`
        )
      }
    })
  }

  if (!searchChatsTechSupport.dialog) {
    return (
      <Box display={'flex'} height={'100%'} alignItems={'center'} justifyContent={'center'}>
        <CircularProgress size={SIZE_PROG} />
      </Box>
    )
  }

  return (
    <Box px={3} height={InnerHeight} overflow={'auto'} display={'flex'} flexDirection={'column'}>
      {searchChatsTechSupport.dialog ? (
        <ChatHeaderInfo
          siteUrl={configurations.all?.find((item) => item.absnum === searchChatsTechSupport.dialog?.site_id)?.url}
          currentChat={searchChatsTechSupport.dialog}
          comeBack={handleCloseDialog}
          createDialog={handleCreateDialog}
        />
      ) : null}
      <CurrentDialog dialog={searchChatsTechSupport.dialog} getDialogMessages={handleGetDialogMessages} />
    </Box>
  )
}
